import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createAppointment = async (payload) => {
  const res = await axios.post(`${API}/appointments`, payload);
  return res.data;
};

export const fetchReviews = async () => {
  const res = await axios.get(`${API}/reviews`);
  return res.data;
};
